export const BUTTON_PROPS = { href: "/signin", value: "Signin" };
